import React from "react";
import AxiosInstance from "../../AxiosInstance";

export const insurerListController = async (isAll) => {
  // const data = localStorage.getItem("insurerList");
  // if (data && !isAll) return JSON.parse(data);

  const result = await AxiosInstance().get(
    isAll ? "/misc/insurerList?isAll=1" : "/misc/insurerList"
  );
  localStorage.setItem("insurerList", JSON.stringify(result.data));
  return result.data;
};
export const productListController = async (id) => {
  const data = localStorage.getItem("productList");
  if (data) return JSON.parse(data);
  const result = await AxiosInstance().get(`/misc/product/${id}`);
  localStorage.setItem("product", JSON.stringify(result.data));
  return result.data;
};
export const banksListController = async () => {
  const data = localStorage.getItem("banksList");
  if (data) return JSON.parse(data);
  const result = await AxiosInstance().get("/misc/banksList");
  localStorage.setItem("banksList", JSON.stringify(result.data));
  return result.data;
};
export const countriesListController = async () => {
  const data = localStorage.getItem("countriesList");
  if (data) return JSON.parse(data);
  const result = await AxiosInstance().get("/misc/countries");
  localStorage.setItem("countriesList", JSON.stringify(result.data));
  return result.data;
};

export const statesListController = async (id) => {
  const result = await AxiosInstance().get(`/misc/states/${id}`);
  return result.data;
};

export const insurersList = {
  MAX:"Max Life Insurance Co. Ltd.",
  AXA:"Bharti AXA Life Insurance Co. Ltd."
}

export const obj2url = (params) =>
  Object.entries(params).reduce(
    (prev, [key, value]) => (value ? prev + `&${key}=${value}` : prev),
    ""
  );